import Immutable from 'immutable';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import 'typeface-lato';

import { func } from 'prop-types';
import { resetState } from '../state/actions/app';
import GroupNavigation from '../components/navigation/GroupNavigation';
import Header from '../components/header/Header';
import TextContent from '../components/common/TextContent';
import styles from '../styles/content.module.styl';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  resetState: () => dispatch(resetState()),
});

class Template extends React.PureComponent {
  componentDidMount() {
    this.props.resetState();
  }

  render() {
    const { data, location, pathContext } = this.props;
    const nodeData = data.allJsonContentsJson.edges[0].node;
    const { pageId, groupId, subPage } = pathContext;
    if (!nodeData) return null;
    const groups = Immutable.fromJS(nodeData.groups);
    return (
      <div>
        <Header
          title={nodeData.title}
          groups={nodeData.groups}
          location={location}
          logo={nodeData.logo}
          pageId={pageId}
          groupId={groupId}
          subPage={subPage}
        />
        <div className={styles.content}>
          <TextContent content={nodeData.introduction} />
          <h2 className={styles.sectionTitle}>{nodeData.whoIsThisToolFor.title}</h2>
          <TextContent content={nodeData.whoIsThisToolFor.content} />
          <h2 className={styles.sectionTitle}>{nodeData.howToApproachTool.title}</h2>
          <TextContent content={nodeData.howToApproachTool.content} />
          <h2 className={styles.sectionTitle}>{nodeData.howThisToolCanHelp.title}</h2>
          <TextContent content={nodeData.howThisToolCanHelp.content} />
          <h2 className={styles.sectionTitle}>{nodeData.chooseGroupHeader}</h2>
          <GroupNavigation groups={groups} pageId={pageId} />
        </div>
      </div>
    );
  }
}

Template.propTypes = {
  children: func,
};

export const query = graphql`
  query StartPageQuery($pageId: String) {
    allJsonContentsJson(filter: { pageId: { eq: $pageId } }) {
      edges {
        node {
          logo
          title
          groups {
            name
            title
          }
          introduction
          whoIsThisToolFor {
            title
            content
          }
          howToApproachTool {
            title
            content
          }
          howThisToolCanHelp {
            title
            content
          }
          chooseGroupHeader
          groups {
            name
          }
        }
      }
    }
  }
`;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Template);



// WEBPACK FOOTER //
// ./src/templates/start-page-template.js